<template>
  <v-container>
    <v-dialog v-model="addLeaveDialog" max-width="500px">
      <template v-slot:activator="{ on }">
        <v-row>
          <v-col md="3" class="pt-0">
            <v-text-field hide-details :label="$t('find_user')" prepend-inner-icon="mdi-magnify" single-line
              v-model="userName" @keyup.enter="getLeaveBalance()"></v-text-field>
          </v-col>
          <v-col md="3" class="pt-0">
            <v-autocomplete v-model="groupSearch" :items="searchGroupList" hide-no-data item-text="alias"
              item-value="id" :label="$t('find_group')" @change="getLeaveBalance()"></v-autocomplete>
          </v-col>
          <v-col md="1" class="pt-0 mt-4">
            <v-btn @click="downloadLeave()" block outlined color="#1976D2" style="border: 1px solid #CDCDCD;">
              <v-icon>mdi-download</v-icon>{{$t('download_report')}}
            </v-btn>
          </v-col>
        </v-row>
      </template>
    </v-dialog>
    <v-dialog v-model="editLeaveDialog" max-width="700px">
      <v-card class="pt-3">
        <v-card-title>
          <span class="headline ml-2">{{$t('edit leave balance')}}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-flex v-if="editedUser" align-self-center class="mb-4">
              <v-avatar size="32" class="ma-1">
                <img v-if="editedUser.avatar_url" :src="editedUser.avatar_url" alt="Avatar" />
                <img v-else src="img/logo_initial_gradient.png" alt="Avatar" />
              </v-avatar>
              <span>
                {{ editedUser.name }}
              </span>
            </v-flex>
            <template v-for="(list, index) in editedUser.leaveList">
              <v-row :key="index">
                <v-col cols="12" sm="12" lg="12" class="d-flex align-center">
                  <b>{{ list.leave_name_in }} ({{ list.leave_category_in }})</b>
                </v-col>
                <v-col sm="12" lg="6">
                  <p>Leave Limit per Year (days)</p>
                  <v-text-field class="centered-input" v-model="list.limit_balance" readonly>
                    <v-icon v-if="!editState" @click="list.limit_balance++"
                      style="background: #1976D2; border-radius: 2px;" slot="append-outer" color="#FFFFFF">
                      mdi-plus
                    </v-icon>
                    <v-icon v-if="!editState" @click="--list.limit_balance" :disabled="list.limit_balance < 1"
                    :style="list.limit_balance < 1 ? 'background: rgb(230, 230, 230); border-radius: 2px;' : 'background: #1976D2; border-radius: 2px;'" style="background: #1976D2; border-radius: 2px;" slot="prepend" color="#FFFFFF">
                      mdi-minus
                    </v-icon>
                  </v-text-field>
                </v-col>
                <v-col sm="12" md="6">
                  <p>Total Leave Taken (days)</p>
                  <v-text-field class="centered-input" v-model="list.total_balance" readonly>
                    <v-icon v-if="!editState" @click="list.total_balance++"
                      style="background: #1976D2; border-radius: 2px;" slot="append-outer" color="#FFFFFF">
                      mdi-plus
                    </v-icon>
                    <v-icon v-if="!editState" @click="--list.total_balance" :disabled="list.total_balance < 1"
                      :style="list.total_balance < 1 ? 'background: rgb(230, 230, 230); border-radius: 2px;' : 'background: #1976D2; border-radius: 2px;'" slot="prepend" color="#FFFFFF">
                      mdi-minus
                    </v-icon>
                  </v-text-field>
                </v-col>
              </v-row>
            </template>
          </v-container>
        </v-card-text>
        <v-card-actions class="mx-6 pb-6">
          <v-row justify="center">
            <v-btn color="primary" style="width: 180px;" v-if="editState" :loading="loading" dark
              @click="editState = !editState">{{$t('edit')}}</v-btn>
            <v-btn color="primary" style="width: 180px;" class="mr-4" v-if="!editState" text @click="close">
              {{$t('cancel')}}</v-btn>
            <v-btn color="primary" style="width: 180px;" v-if="!editState" :loading="loading" dark
              @click="bulkUpdatePerUser(editedUser)">{{$t('save')}}</v-btn>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="detailLeaveDialog" :max-width="tab === 0 ? '1300px' : '700px'">
      <v-card v-if="tab === 0" class="pt-3">
        <v-card-title>
          <span class="headline ml-2">{{$t('employee_leave_detail')}}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-flex align-self-center class="mb-4">
              <v-avatar size="32" class="ma-1">
                <img v-if="userDetail.avatar_url != '-'" :src="userDetail.avatar_url" alt="Avatar" />
                <img v-else src="img/logo_initial_gradient.png" alt="Avatar" />
              </v-avatar>
              <span>
                {{ userDetail.full_name }}
              </span>
            </v-flex>
            <v-row>
              <v-col cols="12" md="4">
                <div class="d-flex align-center">
                  <div>
                    <p>
                      <b>{{ $t('annual_leave') }}</b>
                    </p>
                    <div class="d-flex justify-center">
                      <v-progress-circular :rotate="-90" :size="150" :width="5" :value="calculateAnnual()" color="primary"
                        style="transform: scaleX(-1)">
                        <div class="d-flex flex-column align-center justify-center" style="transform: scaleX(-1)">
                          <h1 class="mb-2">
                            {{annual_taken}}<span class="black--text">/{{annual_limit}}</span>
                          </h1>
                          <p class="mb-0 grey--text">
                            {{$t('annual_leave')}}
                          </p>
                        </div>
                      </v-progress-circular>
                    </div>
                    <div class="d-flex align-center justify-center">
                      <div style="width: 10px; height: 10px; border-radius:50%; background: #1976D2;" class="mr-2">
                      </div>
                      <p class="mb-0">
                        <b>{{$t('annual_leave_taken')}}</b>
                      </p>
                    </div>
                  </div>

                  <div style="width:100%; height:160px; overflow:hidden">
                  <div style="height:100%; overflow-y:auto; overflow-x:hidden;">
                    <v-row>
                      <v-col v-for="(item, i) in annual_leave" :key="i" cols="12"
                        class="card-leave ma-4 d-flex align-center justify-center">
                        <v-row class="d-flex align-center justify-center">
                          <v-col cols="7">
                            <span style="font-size: 12.5px;">{{item.leave_category_in}}</span>
                          </v-col>
                          <v-col cols="5">
                            <span
                              style="font-size: 18px; font-weight: 600; color: #000000;">{{item.amount_taken}}/{{item.limit_balance}}
                            </span>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </div>
                </div>
                </div>
              </v-col>
              <v-col cols="0" md="1" class="pl-8">
                <div style="background: #D9D9D9; width: 1px; height: 100%">
                </div>
              </v-col>
              <v-col cols="12" md="7" class="ml-n4">
                <p class="mb-5">
                  <b>{{ $t('other_leave') }}</b>
                </p>
                <div style="width:100%; height:160px; overflow:hidden">
                  <div style="height:100%; overflow-y:auto; overflow-x:hidden;">
                    <v-row>
                      <v-col v-for="(item, i) in otherLeaveDetail" :key="i" cols="3"
                        class="card-leave ma-4 d-flex align-center justify-center">
                        <v-row class="d-flex align-center justify-center">
                          <v-col cols="7">
                            <span style="font-size: 12.5px;">{{item.leave_category_in}}</span>
                          </v-col>
                          <v-col cols="5">
                            <span
                              style="font-size: 18px; font-weight: 600; color: #000000;">{{item.amount_taken}}/{{item.limit_balance}}
                            </span>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </div>
                </div>
              </v-col>
              <v-col cols="0" md="1">
              </v-col>
              <v-col cols="12">
                <v-data-table :items="detailList" :headers="headersLeaveDetail" :server-items-length="totalDataDetail"
                  :items-per-page="detailPerPage" :loading="detailLoading"
                  @update:page="getLeaveDetails(userIdDetail,$event, detailPerPage)"
                  @update:items-per-page="getLeaveDetails(userIdDetail, detailPage, $event)" class="elevation-1 mt-3 balance"
                  no-data-text="ㅤ"
                  :footer-props="{ 'items-per-page-options': [5, 10, 50, 100], 'items-per-page-text': $t('rows_per_page') }">
                  <template v-slot:item.status="{ item }">
                    <div>{{statusApprovalCheck(item.status)}}</div>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-data-table :loading="loading" :search="search" :items="leave_list" :headers="headers"
      :server-items-length="totalData" :items-per-page="itemPerPage" @update:page="getLeaveBalance($event, itemPerPage)"
      @update:items-per-page="getLeaveBalance(page, $event)" class="elevation-1 mt-3" :no-data-text="$t('no_data')"
      :footer-props="{ 'items-per-page-options': [10, 50, 100], 'items-per-page-text': $t('rows_per_page') }">
      <template v-slot:item.action="{ item }">
        <v-icon small class="mr-2" color="primary" @click="getLeaveDetails(item.userId)">mdi-card-account-details-outline
        </v-icon>
        <v-icon small class="mr-2" color="primary" @click="editedItem(item)">mdi-pencil</v-icon>
      </template>
      <template v-slot:item.working_period="{ item }">
        <div v-if="item.working_period > 0">{{calculateMonths(item.working_period)}}</div>
        <div v-else>Not Works Yet</div>
      </template>
      <template v-slot:item.total_balance="{ item }">
        <div v-if="item.annual_leave_taken">{{item.annual_leave_taken}}</div>
        <div v-else>Not Available Yet</div>
      </template>
      <template v-slot:footer.page-text="items"> {{ items.pageStart }} - {{ items.pageStop }} {{$t('of')}}
        {{ items.itemsLength }} </template>
    </v-data-table>
  </v-container>
</template>

<script>
  import moment from "moment";
  export default {
    name: "leave",
    data() {
      return {
        headers: [{
            text: 'Employee ID',
            value: "employee_code"
          },
          {
            text: 'Full Name',
            value: "full_name"
          },
          {
            text: 'Group',
            value: "groupName",
            align: 'center',
          },
          {
            text: `Working Period (Years & Month)`,
            value: "working_period",
            align: 'center',
          },
          {
            text: `Annual Leave Taken (days)`,
            value: "total_balance",
            align: 'center',
          },
          {
            text: `Other Leave Taken (days)`,
            value: "other_leave_taken",
            align: 'center',
          },
          {
            text: this.$i18n.t('details'),
            value: "action",
            sortable: false
          },
        ],
        headersLeaveDetail: [{
            text: 'Leave Name',
            value: "leave_category_in"
          },
          {
            text: 'Start Date',
            value: "start_date",
            align: 'center',
          },
          {
            text: 'End Date',
            value: "end_date",
            align: 'center',
          },
          {
            text: 'Leave Taken',
            value: "days_taken",
            align: 'center',
          },
          {
            text: 'Approval Status',
            value: "status",
            align: 'center',
          },
          // {
          //   text: this.$i18n.t('details'),
          //   value: "action",
          //   sortable: false
          // },
        ],
        userId: '',
        userIdDetail: '',
        editState: true,

        leaveBalance: [],
        dummyDataLeaveDetail: [{
            leave_name: 'Cuti Tahunan',
            start_date: '25 May 2022',
            end_date: '26 May 2022',
            leave_taken: '1',
            status: 'Need Approval',
          },
          {
            leave_name: 'Cuti Tahunan',
            start_date: '25 May 2022',
            end_date: '26 May 2022',
            leave_taken: '1',
            status: 'Need Approval',
          },
          {
            leave_name: 'Cuti Tahunan',
            start_date: '25 May 2022',
            end_date: '26 May 2022',
            leave_taken: '1',
            status: 'Need Approval',
          },
          {
            leave_name: 'Cuti Tahunan',
            start_date: '25 May 2022',
            end_date: '26 May 2022',
            leave_taken: '1',
            status: 'Need Approval',
          },
          {
            leave_name: 'Cuti Tahunan',
            start_date: '25 May 2022',
            end_date: '26 May 2022',
            leave_taken: '1',
            status: 'Need Approval',
          },
        ],
        appType: [{
            name: this.$i18n.t('1_layer'),
            id: 1,
          },
          {
            name: this.$i18n.t('2_layer'),
            id: 2,
          }
        ],
        company_id: this.$store.state.company,
        validator: this.$store.state.validator,
        baseUrl: this.$store.state.baseUrl,
        leave_list: [],
        search: "",
        detailItem: {
          code: ""
        },
        editedUser: {
          avatar_url: "",
          name: "",
          leaveList: []
        },
        itemToDelete: {
          id: "",
          companyId: "",
        },
        leave: [{
          id: "",
          companyId: "",
        }],
        is_attachment: [{
            name: this.$i18n.t('mandatory'),
            id: true,
          },
          {
            name: this.$i18n.t('not_mandatory'),
            id: false,
          }
        ],
        addLeaveDialog: false,
        detailLeaveDialog: false,
        editLeaveDialog: false,
        loading: false,
        detailLoading: false,
        editedIndex: -1,
        detailIndex: -1,
        amountList: ["0 - Limit", "As Requested"],
        limitList: ["None (-)", "1 - 60"],
        rules: [(v) => !!v || `${this.$i18n.t('required')}`],
        valid: true,
        interval: {},
        value: 0,
        tab: 0,
        totalData: 0,
        totalDataDetail: 0,
        page: 1,
        itemPerPage: 10,
        detailPage: 1,
        detailPerPage: 5,
        userDetail: {},
        detailList: [],
        annual_limit: "-",
        annual_taken: "-",
        annual_leave: [],
        otherLeaveDetail: [],
        userName: '',
        groupSearch: null,
        searchGroupList: [],
      };
    },
    methods: {
      statusApprovalCheck(status) {
        switch (status) {
          case 0:
            return 'Need First Approval';
          case 1:
            return 'Need Second Approval';
          case 2:
            return 'Approved';
          case 3:
            return 'Rejected';
          case 4:
            return 'Need Revision';
          case 5:
            return 'Cancelled';
        }
      },
      calculateAnnual() {
        return this.annual_taken / this.annual_limit * 100
      },
      async downloadLeave() {
        await this.$store.dispatch('downloadLeaveBalance', {
          companyId: this.company_id
        })
      },
      showMessage(type, msg) {
        this.$store.dispatch('nShowMessage', {
          type,
          msg
        })
      },
      checkNone(value) {
        if (value > 0) {
          return value
        } else {
          return 'None'
        }
      },
      dateFormatted(date) {
        return moment(date).format("Do MMMM YYYY");
      },
      calculateMonths(month) {
        const year = Math.floor(month / 12)
        // const month = Math.floor(week / 4)
        const total = month - year * 12
        const resultYear = year > 0 ? year : 0
        const resultMonth = total > 0 ? total : 0
        const textYear = resultYear > 1 ? " Years " : " Year "
        const textMonth = resultMonth > 1 ? " Months" : " Month "
        const finalMonth = resultMonth > 0 ? resultMonth + textMonth : ""
        const finalYear = resultYear > 0 ? resultYear + textYear : ""
        return finalYear + finalMonth
      },
      async getLeaveBalance(page = 1, itemPerPage = 10) {
        this.loading = true
        this.page = page
        this.itemPerPage = itemPerPage
        const result = await this.$store.dispatch('getLBalanceList', {
          companyId: this.company_id,
          pageSize: itemPerPage,
          page: page,
          groupId: this.groupSearch,
          userName: this.userName
        })
        this.totalData = result.total
        this.loading = false
        this.leave_list = result.records;
      },
      async getLeaveDetails(userId, detailPage = 1, detailPerPage = 5) {
        this.userIdDetail = userId
        this.detailLoading = true
        this.detailPage = detailPage
        this.detailPerPage = detailPerPage
        const result = await this.$store.dispatch('getUserBalanceDetail', {
          pageSize: detailPerPage,
          page: detailPage,
          userId: this.userIdDetail 
        })
        this.userDetail = result.user
        this.avatarUrl = result.user.avatar_url
        this.detailList = result.records
        this.totalDataDetail = result.total
        this.annual_leave = result.annual_leave
        this.otherLeaveDetail = result.others_leave
        this.annual_taken = result.annual_taken
        this.annual_limit = result.annual_limit
        this.detailLoading = false
        this.detailLeaveDialog = true;
      },
      addedItem() {
        this.addLeaveDialog = true;
      },
      detailedItem(item) {
        this.detailIndex = this.leave.indexOf(item);
        this.detailItem = Object.assign({}, item);
        this.detailLeaveDialog = true;
        this.getLeaveCategoryList();
      },
      editedItem(item) {
        this.editedIndex = this.leave.indexOf(item);
        this.editLeaveDialog = true;
        this.getLeaveByUser(item);
      },
      deleteItem(item) {
        this.itemToDelete = Object.assign({}, item);
        this.deleteLeaveDialog = true;
      },
      close() {
        this.addLeaveDialog = false;
        this.editLeaveDialog = false;
        this.deleteLeaveDialog = false;
        this.editState = true;
      },
      async getLeaveByUser(item) {
        const result = await this.$store.dispatch('getUserBalanceByUserId', {
          userId: item.userId,
          pageSize: 100,
          page: 1
        })
        if (result) {
          this.editedUser.name = item.full_name
          if (result.avatar_url) {
            this.editedUser.avatar_url = result.avatar_url
          } else {
            this.editedUser.avatar_url = 'img/logo_initial_gradient.png'
          }
          this.editedUser.leaveList = result.records
          this.previousRecords = result.records
          this.userId = item.userId
        }
      },
      async addLeave(item) {
        this.loading = true;
        const result = await this.$store.dispatch('saveLeaveCategory', {
          code: item.code,
          name_id: item.name_id,
          name_en: item.name_en,
          remark_id: item.remark_id,
          remark_en: item.remark_en,
          is_attachment: item.is_attachment,
          companyId: this.company_id,
        })
        this.loading = false;
        if (result) {
          this.addLeaveDialog = false;
          this.getLeaveCategoryList();
          this.showMessage('success', this.$i18n.t('alert_save'))
        } else {
          this.addLeaveDialog = true;
        }
      },
      async bulkUpdatePerUser(item) {
        this.loading = true
        const data = []
        for (const val in item.leaveList) {
          const obj = {}
          obj['total_balance'] = item.leaveList[val].total_balance === "" || item.leaveList[val].total_balance === 0 || !item.leaveList[val].total_balance ? "0" : item.leaveList[val].total_balance
          obj['limit_balance'] = item.leaveList[val].limit_balance === "" || item.leaveList[val].limit_balance === 0 || !item.leaveList[val].limit_balance ? "0" : item.leaveList[val].limit_balance
          obj['leave_company_id'] = item.leaveList[val].id
          data.push(obj)
        }
        const result = await this.$store.dispatch('bulkUpdatePerUser', {
          userId: this.userId,
          data: data
        })
        this.loading = false;
        if (result) {
          this.editLeaveDialog = false;
          this.showMessage('success', this.$i18n.t('alert_save'))
          this.getLeaveBalance();
        } else {
          this.editLeaveDialog = true;
        }
      },
      async getGroupList() {
        const result = await this.$store.dispatch('getGroupByCompany', {
          companyId: this.company_id
        })
        let data = []
        if (result) {
          result.map(item => {
            if (item.is_shifted) data.push(item)
          })
          if (this.role != 3) {
            data.unshift({
              alias: this.$i18n.t('all'),
              id: null
            })
          }
        }
        return data
      },
      async deleteLeave(id) {
        const result = await this.$store.dispatch('deleteLeaveCategory', {
          id
        })
        if (result) {
          this.deleteLeaveDialog = false;
          this.showMessage('success', this.$i18n.t('alert_delete'))
          this.getLeaveCategoryList();
        }
      },


    },
    async created() {
      this.getLeaveBalance();
      this.groupList = await this.getGroupList()
      this.searchGroupList = this.groupList
      if (this.groupList.length > 1) {
        this.groupSearch = this.groupList[0].id
      }
    },
    watch: {
      dialog() {
        this.changeNUserStatus(this.editedItem.status);
        this.changeUserRole(this.editedItem.role);
      },
      addLeaveDialog() {
        if (this.$refs.addForm) {
          this.$refs.addForm.reset();
        }
      },
    },
    beforeDestroy() {
      clearInterval(this.interval)
    },
    mounted() {
      this.interval = setInterval(() => {
        if (this.value === 100) {
          return (this.value = 0)
        }
        this.value += 10
      }, 1000)
    },
  };
</script>

<style scoped>
  .balance>>>.v-data-table__empty-wrapper {
    background-image: url(/img/empty.png);
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-position: 50% 73%;
    height: 300px;
    /* background-position: center; */
    /* background-position: 50% 71%, 50% 82%; */
    /* background-image: url(/img/empty.png) ,url(/img/empty-list.png); */
  }

  .v-progress-circular {
    margin: 1rem;
  }

  .centered-input>>>input {
    text-align: center
  }

  .card-leave {
    max-width: 200px !important;
    height: 58px;
    border-radius: 12px;
    box-shadow: 0px 8px 10px rgba(180, 180, 180, 0.14), 0px 3px 14px rgba(180, 180, 180, 0.12), 0px 5px 5px rgba(180, 180, 180, 0.2);
  }
</style>